var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.01,
    height: 25.01,
    viewBox: "0 0 25.01 25.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "more",
    fill: "#fff",
    d: "M23.76 11.255h-10v-10a1.251 1.251 0 0 0-2.5 0v10h-10a1.251 1.251 0 0 0 0 2.5h10v10a1.251 1.251 0 1 0 2.5 0v-10h10a1.251 1.251 0 1 0 0-2.5zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.76890780e4a7e716bf907e6887099630.svg";
export { ForwardRef as ReactComponent };